import { render, staticRenderFns } from "./OurCoursesListing.vue?vue&type=template&id=88bf6d8e&"
import script from "./OurCoursesListing.vue?vue&type=script&lang=js&"
export * from "./OurCoursesListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports